module.exports = __webpack_public_path__ + "Icono_Cervical-Ngr_126px.png";